export default __webpack_public_path__ + "logo.3548995124fb9286d40709194b85b3f0.svg";